import React, { Component, Fragment } from "react";
import ReactTable from "react-table";
import moment from "moment";
import { Switch } from "antd";
import InvoiceView from "./invoiceView";
import { apiURL } from "../../../utlis/config";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
const formatTime = (date) => {
  date = moment(date).format("MMMM Do / YYYY, hh:mm A").split("/");
  return (
    <div>
      <p style={{ margin: 1 }}>{date[0]}</p>
      <p style={{ margin: 1 }}>{date[1]}</p>
    </div>
  );
};
export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
      myData: [],
      modalDelete: false,
    };
  }
  componentDidMount() {
    this.setState({
      checkedValues: [],
      myData: this.props.myData,
      modalDelete: false,
    });
    //console.log("------------", this.props);
  }

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  handleRemoveRow = () => {
    const { removeScanedEmail } = this.props;
    this.setState({ modalDelete: false });
    removeScanedEmail(this.state.checkedValues);
  };

  renderEditable = (cellInfo) => {
    return (
      <div
        style={{ backgroundColor: "#fafafa" }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const data = [...this.props.myData];
          data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          // this.setState({ myData: data });
        }}
        dangerouslySetInnerHTML={{
          __html: this.props.myData[cellInfo.index][cellInfo.column.id],
        }}
      />
    );
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    const {
      loading,
      pageSize,
      page,
      totalRecords,
      myClass,
      multiSelectOption,
      pagination,
      onChangePageSize,
      onChangePage,
      myData,
      invoiceStatus,
      onEditInvoiceInfo,
      onChangeActive,
    } = this.props;
    console.log({ props: this.props });
    const columns = [
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
            Invoice Number
          </h6>
        ),
        accessor: "invoiceNumber",
        Cell: null,
        style: {
          textAlign: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
            Ship To
          </h6>
        ),
        accessor: "shipTo",
        Cell: null,
        style: {
          textAlign: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
            Payment Terms
          </h6>
        ),
        accessor: "paymentTerms",
        Cell: null,
        style: {
          textAlign: "center",
        },
      },

      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Url
      //     </h6>
      //   ),
      //   accessor: "sUrl",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
            Date
          </h6>
        ),
        accessor: "createdAt",
        Cell: ({ value }) => {
          return <div>{formatTime(value)}</div>;
        },

        heigth: 40,
        style: {
          textAlign: "center",
        },
      },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
            Total Amount
          </h6>
        ),
        accessor: "total",
        width: 200,
        Cell: ({ value }) => {
          return (
            <div
              style={{
                whiteSpace: "normal",
                // textAlign: "justify",
              }}
            >
              ${value}
            </div>
          );
        },
        style: {
          textAlign: "center",
        },
      },
    ];
    columns.push({
      Header: (
        <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
          Action
        </h6>
      ),
      id: "delete",
      width: 100,
      accessor: (str) => "delete",
      Cell: ({ original, index }) => (
        <div>
          <span
            onClick={() => {
              onEditInvoiceInfo(index, original);
              //  this.setState({
              //    modalEdit: true,
              //    index: index,
              //    dealerId: original._id,
              //  });
            }}
            style={{ cursor: "pointer" }}
            title="Download Invoice"
          >
            <i
              className="fa fa-download"
              style={{
                width: 35,
                fontSize: 20,
                padding: 5,
                color: "#1890ff",
              }}
            ></i>
          </span>
        </div>
      ),
      style: {
        textAlign: "center",
        fontWeight: "600",
      },
      sortable: false,
    });
    console.log({ totalRecords, page, pageSize });
    return (
      <Fragment>
        <ReactTable
          manual
          data={myData}
          columns={columns}
          className={myClass}
          loading={loading}
          pages={totalRecords}
          page={page}
          pageSize={pageSize || 10}
          // defaultPageSize={pageSize}
          showPagination={pagination}
          onPageChange={(pageIndex) => onChangePage(pageIndex)}
          onPageSizeChange={(pageSize, pageIndex) =>
            // //console.log({ pageSize, pageIndex })
            onChangePageSize(pageSize)
          }
          showPagination={pagination}
          onFetchData={(state, instance) => console.log({ state, instance })}
          SubComponent={(v) => {
            console.log({ v });
            var original = v.original;
            return <InvoiceView original={original} />;
            // <EmailBodyInfo index={v.row._index} myData={myData} />
          }}
        />
        {/* <ToastContainer /> */}
      </Fragment>
    );
  }
}

export default Datatable;
